import React from 'react';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';
import { BarChart3Icon } from 'lucide-react';

import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import NpsCampaignResultsPanel from './NpsCampaignResultsPanel';

interface IProps {
  campaign: NpsCampaignDto;
  disabled?: boolean;
  disabledReason?: string;
  showComments?: boolean;
}

const NpsCampaignResultsDialog: React.FC<IProps> = ({
  campaign,
  disabled,
  disabledReason,
  showComments = true,
}) => {
  const { checkAuthorization } = useAuthSessionStore();
  const canViewComments = checkAuthorization(({ can }) =>
    can('viewComments', 'nps'),
  );

  return (
    <Dialog
      title={`Resultados — ${campaign.name}`}
      description="Visão geral dos resultados por linha, horário e comentários."
      className="sm:max-w-[1100px]"
      tooltipContent={
        disabled
          ? (disabledReason ??
            'Os resultados desta campanha não estão disponíveis para o seu perfil.')
          : 'Ver resultados'
      }
      trigger={
        <Button
          variant="outline"
          size="icon-sm"
          disabled={disabled}
          aria-label={`Ver resultados de ${campaign.name}`}
        >
          <BarChart3Icon data-icon="inline-start" />
        </Button>
      }
    >
      <NpsCampaignResultsPanel
        campaign={campaign}
        canViewComments={canViewComments}
        showComments={showComments}
      />
    </Dialog>
  );
};

export default NpsCampaignResultsDialog;
